import { InjectionToken } from '@angular/core';

export interface TranslateService {
  instant(key: string): string;
}

export const TRANSLATE_SERVICE_TOKEN = new InjectionToken<TranslateService>('TranslateService');
